import Button from '@repo/ui/button'

type Props = {
  isLoading?: boolean
  disabled?: boolean
  onSubmit: () => void
  onCancel: () => void
  cancelLabel?: string
  variant?: 'button' | 'submit'
}

const ActionButtons = ({
  isLoading,
  disabled,
  variant = 'button',
  onCancel,
  onSubmit,
  cancelLabel
}: Props) => {
  return (
    <div className="flex flex-row justify-end items-center mt-5 gap-3 border-t border-t-white-active p-5">
      <Button
        disabled={isLoading}
        variant="ghost"
        type="button"
        label={cancelLabel || 'Fermer'}
        aria-label={'Fermer'}
        onClick={onCancel}
      />
      <Button
        loading={isLoading}
        type={variant}
        disabled={disabled || isLoading}
        variant="primary"
        label={'Valider'}
        aria-label={'Valider'}
        onClick={onSubmit}
      />
    </div>
  )
}

export default ActionButtons
